<template>
  <div>
    <div class="flex justify-between px-4 items-center mt-10">
      <h1 class="text-3xl font-bold text-center">{{ __("Notifications") }}</h1>
    </div>

    <div class="bg-white p-4 shadow-md mt-10 ">
      <table class="w-full" v-if="notifications.data.length">
        <tr class="bg-gray-700 text-gray-100">
          <th class="p-4 text-left">{{ __("Title") }}</th>
          <th class="p-4 text-left">{{ __("Received at") }}</th>
        </tr>
        <tr v-for="(notification, index) in notifications.data"
            :class="{'bg-gray-300': index%2 === 0}">
          <td class="p-4 flex items-center">
            <div class="bg-coral-400 h-4 w-4 mr-2 rounded-full"
                 v-if="notification.read_at === null"></div>
            <inertia-link class="hover:text-coral-400"
                          :href="route('notifications.show', {notification: notification.id})">{{ notification.title }}
            </inertia-link>
          </td>
          <td class="p-4">{{ notification.created_at }}</td>
        </tr>
      </table>
      <div v-else>
        {{ __("No notifications at the moment...") }}
      </div>
    </div>

    <pagination :links="notifications.meta.links"/>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';
  import Pagination from '@/Shared/Pagination';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: 'Notifications'
      }
    },
    props: {
      notifications: Object,
    },
    components: {
      Layout,
      Pagination,
      Icon
    }
  }
</script>
